import { useAppStore } from '@/store';
import type { MpApp } from '@/types/global-business';
import { onBeforeUnmount } from 'vue';
export const useResourcePreview = () => {
  const appStore = useAppStore();

  const resourcePreview = (options: MpApp.ResourcePreviewOptions) => {
    appStore.resourcePreviewerOptions = {
      ...options,
      display: true,
    };
  };

  onBeforeUnmount(() => {
    appStore.resourcePreviewerOptions = {
      data: [],
      defaultIndex: 0,
      display: false,
    };
  });

  return {
    resourcePreview,
  };
};
